

import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class KionButton extends Vue {
	@Prop({default: false}) disabled!: boolean
	@Prop( {default: false}) negative!: boolean
}
